<template>
  <div class="sr_kind_editor">
    <template>
      <textarea :id="id" name="content" v-model="outContent" :maxlength="5"></textarea>
      <template v-if="platform == 'default'">
        <SrBigUpload :item="uploadItem" ref="srbigupload" style="display: none" @uploadImgSuccess="uploadSuccess" />
      </template>
      <template v-else>
        <SrUpload :item="uploadItem1" :formComConfig="config" ref="srbigupload" style="display: none"
          @imgChange="uploadSuccess" />
      </template>

    </template>
  </div>
</template>

<script>
import "kindeditor/kindeditor-all-min.js";
import "kindeditor/themes/default/default.css";
import "kindeditor/lang/zh-CN.js";

export default {
  name: "SrKindEditor",
  data() {
    return {
      editor: null,
      outContent: this.content,
      contentLength: 0,
      uploadItem: {
        limit: 500,
        fileType: "jpg,jpeg,jpe,png",
        target: "editor",
      },
      uploadItem1: {
        limit: 500,
        fileType: "jpg,jpeg,jpe,png",
        target: "editor",
        fileList: []
      },
      config: {
        labelNum: 190,
        labelSuffix: '',
        labelPosition: 'top',
        textModel: false
      }
    };
  },
  inject: ["baseUrl", "imgBaseUrl", "uploadRequest", "uploadBaseUrl", "previewUrl"],
  props: {
    // 控制编辑器是否是只读
    readonlyMode: {
      type: Boolean,
      default: false
    },
    header: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: '180'
    },
    minWidth: {
      type: Number,
      default: 1000
    },
    minHeight: {
      type: Number,
      // default: 71
    },
    items: {
      type: Array,
      default: function () {
        return [
          "formatblock",
          // "fontname",
          "fontsize",
          "|",
          "forecolor", // 文字颜色
          "hilitecolor", // 背景颜色
          "bold", // 加粗
          "italic", // 斜体
          "underline", // 下划线
          // "strikethrough", // 删除线
          "lineheight", // 行距
          "|",
          "justifyleft",
          "justifycenter",
          "justifyright",
          "justifyfull",
          "insertorderedlist",
          "insertunorderedlist",
          "indent",
          "outdent",
          "|",
          "emoticons", // 表情
          "image", // 图片上传
          "table", // 插入表格
          "link", // 超级链接
          "unlink", // 取消超级链接
          "|",
          "removeformat", // 删除格式
          "undo", //前进
          "redo", //后退
          "fullscreen", // 全屏
          // "source", // html代码
          "about", // 关于
          // "preview",//预览
          // "print",//打印
          // "template",// 插入模版
          // "code",// 插入程序代码
          // "cut",// 剪切
          "copy" // 复制
          // "paste", // 粘贴
          // "plainpaste", // 粘贴为无格式文本
          // "wordpaste", // 从word粘贴
          // "subscript", // 下标
          // "superscript", // 上标
          // "clearhtml", // 清理html代码
          // "quickformat", // 一键排版
          // "selectall", // 全选
          // "/",
          // "multiimage", // 多图片上传
          // "flash",
          // "media",
          // "insertfile", // 插入文件
          // "hr", // 插入横线
          // "baidumap", // 百度地图
          // "pagebreak", // 插入分页符
          // "anchor", //锚点
        ];
      }
    },
    noDisableItems: {
      type: Array,
      default: function () {
        return ["source", "fullscreen"];
      }
    },
    filterMode: {
      type: Boolean,
      default: true
    },
    htmlTags: {
      type: Object,
      default: function () {
        return {
          font: ["color", "size", "face", ".background-color"],
          span: ["style"],
          div: ["class", "align", "style"],
          table: [
            "class",
            "border",
            "cellspacing",
            "cellpadding",
            "width",
            "height",
            "align",
            "style"
          ],
          "td,th": [
            "class",
            "align",
            "valign",
            "width",
            "height",
            "colspan",
            "rowspan",
            "bgcolor",
            "style"
          ],
          a: ["class", "href", "target", "name", "style"],
          embed: [
            "src",
            "width",
            "height",
            "type",
            "loop",
            "autostart",
            "quality",
            "style",
            "align",
            "allowscriptaccess",
            "/"
          ],
          img: [
            "src",
            "width",
            "height",
            "border",
            "alt",
            "title",
            "align",
            "style",
            "/"
          ],
          hr: ["class", "/"],
          br: ["/"],
          "p,ol,ul,li,blockquote,h1,h2,h3,h4,h5,h6": ["align", "style"],
          "tbody,tr,strong,b,sub,sup,em,i,u,strike": []
        };
      }
    },
    wellFormatMode: {
      type: Boolean,
      default: true
    },
    resizeType: {
      type: Number,
      default: 1
    },
    themeType: {
      type: String,
      default: "default"
    },
    langType: {
      type: String,
      default: "zh-CN"
    },
    designMode: {
      type: Boolean,
      default: true
    },
    fullscreenMode: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    },
    themesPath: {
      type: String,
      default: ""
    },
    pluginsPath: {
      type: String,
      default: ""
    },
    langPath: {
      type: String
    },
    minChangeSize: {
      type: Number,
      default: 5
    },
    loadStyleMode: {
      type: Boolean,
      default: true
    },
    urlType: {
      type: String,
      default: ""
    },
    newlineTag: {
      type: String,
      default: "p"
    },
    pasteType: {
      type: Number,
      default: 2
    },
    dialogAlignType: {
      type: String,
      default: "page"
    },
    shadowMode: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: 811213
    },
    useContextmenu: {
      type: Boolean,
      default: true
    },
    syncType: {
      type: String,
      default: "form"
    },
    indentChar: {
      type: String,
      default: "\t"
    },
    cssPath: {
      type: [String, Array]
    },
    cssData: {
      type: String
    },
    bodyClass: {
      type: String,
      default: "ke-content"
    },
    colorTable: {
      type: Array
    },
    afterCreate: {
      type: Function
    },
    afterChange: {
      type: Function
    },
    afterTab: {
      type: Function
    },
    afterFocus: {
      type: Function
    },
    afterBlur: {
      type: Function
    },
    afterUpload: {
      type: Function
    },
    uploadJson: {
      //指定上传文件的服务器端程序
      type: String
    },
    fileManagerJson: {
      //指定浏览远程图片的服务器端程序
      type: String
    },
    allowPreviewEmoticons: {
      type: Boolean,
      default: true
    },
    allowImageUpload: {
      type: Boolean,
      default: true
    },
    allowFlashUpload: {
      type: Boolean,
      default: true
    },
    allowMediaUpload: {
      type: Boolean,
      default: true
    },
    allowFileUpload: {
      type: Boolean,
      default: true
    },
    allowFileManager: {
      type: Boolean,
      default: false
    },
    fontSizeTable: {
      type: Array,
      default: function () {
        return ["9px", "10px", "12px", "14px", "16px", "18px", "24px", "32px"];
      }
    },
    imageTabIndex: {
      type: Number,
      default: 0
    },
    formatUploadUrl: {
      type: Boolean,
      default: true
    },
    fullscreenShortcut: {
      type: Boolean,
      default: false
    },
    extraFileUploadParams: {
      type: Object,
      default: function () {
        return {};
      }
    },
    filePostName: {
      type: String,
      default: "imgFile"
    },
    fillDescAfterUploadImage: {
      type: Boolean,
      default: false
    },
    afterSelectFile: {
      // 从图片空间选择文件后执行的回调函数
      type: Function
    },
    pagebreakHtml: {
      type: String,
      default: '<hr style="page-break-after: always;" class="ke-pagebreak" />'
    },
    allowImageRemote: {
      type: Boolean,
      default: true
    },
    autoHeightMode: {
      type: Boolean,
      // default: true
    },
    fixToolBar: {
      type: Boolean,
      default: false
    },
    tabIndex: {
      type: Number
    },
    maxlength: {
      type: Number,
      default: 500
    },
    item: {
      type: Object,
      default: {}
    },
    // formComConfig: {
    //   type: Object,
    //   default: {}
    // },
    platform: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    // 是否采用文字模式
    // getTextModel() {
    //   if (undefined === this.item.isText || "" === this.item.isText) {
    //     // item没有设置是否纯文本显示，判断全局的textModel
    //     return this.formComConfig.textModel;
    //   } else {
    //     return this.item.isText;
    //   }
    // }
  },
  watch: {
    content(val) {
      this.editor && val !== this.outContent && this.editor.html(val);
    },
    outContent(val) {
      this.$emit("update:content", val);
      this.$emit("on-content-change", val);
    }
  },
  mounted() {
    // 初始访问时创建
    this.initEditor();
  },
  /**
   * keep-alive 会用到进入时调用activated 离开时调用deactivated
   * 初始访问 created、mounted 切换时deactivated 再次进入时 activated
   */
  activated() {
    // keep-alive 进入时创建
    this.initEditor();
  },
  deactivated() {
    // keep-alive 离开时移除
    this.removeEditor();
  },
  methods: {
    uploadSuccess(res) {
      console.log("上传成功", res);
      // 获取富文本组件实例
      this.editor.insertHtml(`<img src="${res.fileUrl}" />`);
    },
    removeEditor() {
      window.KindEditor.remove("#" + this.id);
    },
    initEditor() {
      if (this.getTextModel) return;
      var _this = this;
      _this.removeEditor();
      _this.editor = window.KindEditor.create("#" + this.id, {
        readonlyMode: _this.readonlyMode,
        header: _this.header,
        width: _this.width,
        height: _this.height,
        minWidth: _this.minWidth,
        minHeight: _this.minHeight,
        items: _this.items,
        noDisableItems: _this.noDisableItems,
        filterMode: _this.filterMode,
        htmlTags: _this.htmlTags,
        wellFormatMode: _this.wellFormatMode,
        resizeType: _this.resizeType,
        themeType: _this.themeType,
        langType: _this.langType,
        designMode: _this.designMode,
        fullscreenMode: _this.fullscreenMode,
        basePath: _this.basePath,
        themesPath: _this.themesPath,
        pluginsPath: _this.pluginsPath,
        langPath: _this.langPath,
        minChangeSize: _this.minChangeSize,
        loadStyleMode: _this.loadStyleMode,
        urlType: _this.urlType,
        newlineTag: _this.newlineTag,
        pasteType: _this.pasteType,
        dialogAlignType: _this.dialogAlignType,
        shadowMode: _this.shadowMode,
        zIndex: _this.zIndex,
        useContextmenu: _this.useContextmenu,
        syncType: _this.syncType,
        indentChar: _this.indentChar,
        cssPath: _this.cssPath,
        cssData: _this.cssData,
        bodyClass: _this.bodyClass,
        colorTable: _this.colorTable,
        afterCreate: function () {
          this.clickToolbar("image", function () {
            if (_this.maxlength >= 0 && _this.contentLength < _this.maxlength) {
              _this.$refs.srbigupload.$children[0].$children[0].$el.click();
            }
            this.hideDialog();
          });

          var doc = this.edit.doc;
          var cmd = this.edit.cmd;
          var K = window.KindEditor;
          K(doc.body).bind("paste", function (ev) {
            // if (this.platform != 'default') {
            //   let ele = ev.event.clipboardData.items
            //   for (var i = 0; i < ele.length; ++i) {
            //     if (ele[i].kind == 'file' && ele[i].type.indexOf('image/') !== -1) {
            //       var file = ele[i].getAsFile();//得到二进制数据
            //       var formData = new FormData();
            //       formData.append("file", file);
            //       let res = _this.uploadRequest.imgUpload(formData);
            //       console.log(res, 'formData.appendformData.append');
            //     }
            //   }
            // }
            setTimeout(async function () {
              const copyHtml = _this.editor.html();
              let div = document.createElement("div");
              div.innerHTML = copyHtml;
              if (this.platform == 'default') {
                const base64Imgs = [...div.getElementsByTagName("img")].filter(
                  (img) => img.src.search(/data:.+;base64,/) > -1
                );
                const imgResults = base64Imgs.map(async (img, index) => {
                  let base64Url = img.src;
                  let lastName = "";
                  base64Url = base64Url.replace(/data:.+;base64,/, (word) => {
                    lastName = word.match(/:image\/(.*?);/)[1];
                    return "";
                  });
                  let res = await _this.uploadRequest.uploadBase64({ file: base64Url, suffix: lastName });
                  return res;
                });

                for (let i = 0; i < imgResults.length; i++) {
                  const res = await imgResults[i];
                  if (res && res.code == '1000') {
                    if (res.data && res.data.fileUrl) {
                      // let url = config.getEncryUrl(res.data.id);
                      base64Imgs[i].src = res.data.fileUrl;
                      // base64Imgs[i].style = "width: 100%;";
                      base64Imgs[i].setAttribute("data-ke-src", "");
                      base64Imgs[i].setAttribute("id", base64Imgs[i].id);
                    }
                  }
                }
              }
              _this.editor.html(div.innerHTML);
              div = null;
            }, 80);
          });
        },
        afterChange: function () {
          _this.outContent = this.html();
          let len = this.text();
          if (len) {
            len = len.length;
            _this.$set(_this.item, "nowLength", len);
          }

          _this.contentLength = this.count("text");
          _this.$emit("onEditorChange");
        },
        afterTab: _this.afterTab,
        afterFocus: _this.afterFocus,
        afterBlur: function () {
          _this.$emit("onEditorBlur");
        },
        afterUpload: _this.afterUpload,
        uploadJson: _this.uploadJson,
        fileManagerJson: _this.fileManagerJson,
        allowPreviewEmoticons: _this.allowPreviewEmoticons,
        allowImageUpload: _this.allowImageUpload,
        allowFlashUpload: _this.allowFlashUpload,
        allowMediaUpload: _this.allowMediaUpload,
        allowFileUpload: _this.allowFileUpload,
        allowFileManager: _this.allowFileManager,
        fontSizeTable: _this.fontSizeTable,
        imageTabIndex: _this.imageTabIndex,
        formatUploadUrl: _this.formatUploadUrl,
        fullscreenShortcut: _this.fullscreenShortcut,
        extraFileUploadParams: _this.extraFileUploadParams,
        filePostName: _this.filePostName,
        fillDescAfterUploadImage: _this.fillDescAfterUploadImage,
        afterSelectFile: _this.afterSelectFile,
        pagebreakHtml: _this.pagebreakHtml,
        allowImageRemote: _this.allowImageRemote,
        autoHeightMode: _this.autoHeightMode,
        fixToolBar: _this.fixToolBar,
        tabIndex: _this.tabIndex
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// packages/SrKindEditor/index.vue